import { useEffect } from 'react'

const isEditable = (node) => Boolean(
  node?.closest?.('input, textarea, select, [contenteditable="true"], [contenteditable=""]')
)

const isMedia = (node) => {
  if (!node) return false
  if (node.nodeType === 3) node = node.parentElement
  return Boolean(node?.closest?.('img, video, canvas, picture, svg'))
}

const MediaGuard = () => {
  useEffect(() => {
    const onContextMenu = (event) => {
      if (isEditable(event.target)) return
      event.preventDefault()
    }

    const onDragStart = (event) => {
      if (isMedia(event.target)) event.preventDefault()
    }

    const onSelectStart = (event) => {
      if (isEditable(event.target)) return
      event.preventDefault()
    }

    const onCopyCut = (event) => {
      if (isEditable(event.target)) return
      event.preventDefault()
    }

    document.addEventListener('contextmenu', onContextMenu)
    document.addEventListener('dragstart', onDragStart)
    document.addEventListener('selectstart', onSelectStart)
    document.addEventListener('copy', onCopyCut)
    document.addEventListener('cut', onCopyCut)

    return () => {
      document.removeEventListener('contextmenu', onContextMenu)
      document.removeEventListener('dragstart', onDragStart)
      document.removeEventListener('selectstart', onSelectStart)
      document.removeEventListener('copy', onCopyCut)
      document.removeEventListener('cut', onCopyCut)
    }
  }, [])

  return null
}

export default MediaGuard
